const mixinWithDialog = {
  data() {
    return {
      modals: {
        create: false,
        disabledField: false,
      },
    };
  },
  methods: {
    handleOpenModal(data) {
      this.modals = { create: true, disabledField: data };
    },
    handleCloseModal(data) {
      this.modals = { create: false, disabledField: data };
      
      try {
        this.forceRerender();
      } catch (error) {}
    },
  },
};

export default mixinWithDialog;
